// Product card / PDP summary behaviors migrated from legacy `js/product.js`.

function toggleDescription(buttonSelector, descriptionSelector) {
  const button = document.querySelector(buttonSelector);
  const description = document.querySelector(descriptionSelector);
  const buttonText = button ? button.querySelector("b") : null;

  if (!button || !description || !buttonText) return;

  button.addEventListener("click", () => {
    description.classList.toggle("active");
    button.classList.toggle("active");

    const isActive = description.classList.contains("active");
    buttonText.textContent = isActive
      ? button.getAttribute("data-close")
      : button.getAttribute("data-open");
  });
}

// Accordion + labs link moved to `product-meta-desc` component.

function initSubscriptionToggle() {
  const optionRadios = document.querySelectorAll(".wcsatt-options-prompt-radio");
  if (!optionRadios.length) return;

  optionRadios.forEach((radioItem) => {
    const label = radioItem.querySelector("label");
    if (!label) return;

    label.addEventListener("click", () => {
      optionRadios.forEach((item) => item.classList.remove("active"));
      radioItem.classList.add("active");
    });
  });
}

function initDefaultSubscriptionSelected() {
  // WCS ATT may override server-side `checked` after its own init.
  // We enforce default selection to "subscription" and keep `.active` in sync.
  const root = document.querySelector(".c-product-card");
  if (!root) return;

  let isEnforcing = false;
  let rafId = 0;
  let userInteracted = false;
  let stopAfterMsTimer = 0;
  let mo = null;
  const startedAt = Date.now();
  const ENFORCE_WINDOW_MS = 2000;

  const stopEnforcing = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    if (stopAfterMsTimer) window.clearTimeout(stopAfterMsTimer);
    stopAfterMsTimer = 0;
    if (mo) mo.disconnect();
    mo = null;
  };

  // If the user changes selection, never override it again.
  root.addEventListener(
    "change",
    (e) => {
      if (
        e.target &&
        e.target.matches("input[name='subscribe-to-action-input']")
      ) {
        userInteracted = true;
        stopEnforcing();
      }
    },
    true
  );

  const apply = () => {
    if (isEnforcing) return false;
    if (userInteracted) return false;
    if (Date.now() - startedAt > ENFORCE_WINDOW_MS) return false;
    const subInput = root.querySelector(
      "input[name='subscribe-to-action-input'][value='yes']"
    );
    const oneInput = root.querySelector(
      "input[name='subscribe-to-action-input'][value='no']"
    );
    if (!subInput || !oneInput) return false;

    isEnforcing = true;
    try {
      if (!subInput.checked) {
        subInput.checked = true;
        oneInput.checked = false;
        // Trigger both events to satisfy various listeners.
        subInput.dispatchEvent(new Event("change", { bubbles: true }));
        subInput.dispatchEvent(new Event("input", { bubbles: true }));
      }

    const subItem = subInput.closest(".wcsatt-options-prompt-radio");
      if (subItem) {
        const items = root.querySelectorAll(".wcsatt-options-prompt-radio");
        const hasCorrectActive =
          subItem.classList.contains("active") &&
          Array.from(items).every((el) => el === subItem || !el.classList.contains("active"));
        if (!hasCorrectActive) {
          items.forEach((el) => el.classList.remove("active"));
          subItem.classList.add("active");
        }
      }
      return true;
    } finally {
      isEnforcing = false;
    }
  };

  // Run now + after a couple ticks (plugin often mutates DOM after load).
  apply();
  window.setTimeout(apply, 0);
  window.setTimeout(apply, 50);
  window.setTimeout(apply, 150);
  window.setTimeout(apply, 400);

  // Hard stop even if plugin keeps re-rendering.
  stopAfterMsTimer = window.setTimeout(() => stopEnforcing(), ENFORCE_WINDOW_MS);

  // Also react to plugin rerenders.
  if (typeof MutationObserver !== "undefined") {
    mo = new MutationObserver(() => {
      if (isEnforcing) return;
      if (userInteracted) return;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        apply();
      });
    });
    // Observe structural changes only (avoid attribute loops from classList changes).
    mo.observe(root, { subtree: true, childList: true });
  }
}

function initSubscriptionOptionsLayout() {
  // Design places the plan selector ("Dostawa co") and the "add to an existing
  // subscription" link INSIDE the subscription box, below the benefits. In the
  // plugin markup they render as siblings of the prompt radios, so we reparent
  // them into the subscription <li>. WCS ATT Backbone views resolve these via
  // `$form.find(...)`, so a move within the same form keeps events/prices intact.
  const root = document.querySelector(".c-product-card") || document;

  const move = () => {
    // Re-queried each time: on variable products the plugin re-renders the
    // whole options block after every variation change.
    const subItem = root.querySelector(
      ".wcsatt-options-prompt-radio--subscription"
    );
    if (!subItem) return false;

    // Move the newest block rendered outside the box; drop a stale copy we
    // moved earlier (two <select>s with the same name would both submit).
    const adopt = (selector) => {
      const all = Array.from(root.querySelectorAll(selector));
      const outside = all.filter((el) => !subItem.contains(el));
      if (!outside.length) return all.length > 0;
      all.filter((el) => subItem.contains(el)).forEach((el) => el.remove());
      subItem.appendChild(outside[outside.length - 1]);
      return true;
    };

    const hasSelector = adopt(".wcsatt-options-product-wrapper");
    adopt(".wcsatt-add-to-subscription-wrapper");

    // Keep the add-to-subscription link last, after the selector.
    const link = subItem.querySelector(".wcsatt-add-to-subscription-wrapper");
    if (link && link !== subItem.lastElementChild) {
      subItem.appendChild(link);
    }

    return hasSelector;
  };

  // Run now and shortly after — the plugin hydrates its markup post-load.
  if (!move()) {
    let tries = 0;
    const retry = () => {
      if (tries >= 10 || move()) return;
      tries += 1;
      window.setTimeout(retry, 100);
    };
    window.setTimeout(retry, 100);
  }

  // Variable products: the selector appears only after a variation is found
  // (often later than the retries above) and is rebuilt on every variation
  // change — move it again whenever the plugin renders a new one.
  observeProductCard(root, move);
}

// Calls `callback` (at most once per frame) after DOM nodes change inside `root`.
function observeProductCard(root, callback) {
  if (!("MutationObserver" in window) || root === document) return;
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      callback();
    });
  });
  observer.observe(root, { childList: true, subtree: true });
}

function initSubscriptionSchemePriceSync() {
  // When the customer switches the delivery plan ("Dostawa co"), mirror the
  // selected plan's price + discount onto the subscription box headline price,
  // its "-XX%" badge and the add-to-cart button. The plugin doesn't do this for
  // the box/button, so we read each plan's server-rendered price from the
  // (hidden) radio list it also outputs, keeping numbers consistent with what
  // the plugin computed for the current customer.
  const root = document.querySelector(".c-product-card");
  if (!root) return;

  // Read a plan's price/discount from the plugin's (hidden) radio list. Queried
  // fresh each time — the plugin re-renders these nodes, so cached refs go stale.
  const getSchemeData = (schemeKey) => {
    const li = Array.from(
      root.querySelectorAll("ul.wcsatt-options-product > li.subscription-option")
    ).find((item) => {
      const input = item.querySelector("input");
      return input && input.value === schemeKey;
    });
    const details = li && li.querySelector(".subscription-option-details");
    if (!details) return null;

    // Current price = the discounted <ins> amount when on sale, else the amount.
    const amountEl =
      details.querySelector("ins .woocommerce-Price-amount") ||
      details.querySelector(".woocommerce-Price-amount");
    const priceHTML = amountEl ? amountEl.outerHTML : null;
    const priceText = amountEl
      ? amountEl.textContent.replace(/\s+/g, " ").trim()
      : null;

    // Discount % from "…— save X%", falling back to the "(X% off)" option text.
    let discount = 0;
    const m = details.textContent.match(/(\d+)\s*%/);
    if (m) {
      discount = parseInt(m[1], 10);
    } else {
      const select = root.querySelector("select.wcsatt-options-product-dropdown");
      const opt =
        select &&
        Array.from(select.options).find((o) => o.value === schemeKey);
      const om = opt && opt.textContent.match(/(\d+)\s*%/);
      if (om) discount = parseInt(om[1], 10);
    }

    return { priceHTML, priceText, discount };
  };

  const sync = () => {
    const select = root.querySelector("select.wcsatt-options-product-dropdown");
    if (!select) return;
    const data = getSchemeData(select.value);
    if (!data) return;

    // Set data-price-text first so the button-label logic reads the new value.
    const subInput = root.querySelector(
      "input[name='subscribe-to-action-input'][value='yes']"
    );
    if (subInput && data.priceText) {
      subInput.dataset.priceText = data.priceText;
    }

    const priceEl = root.querySelector(
      ".wcsatt-options-prompt-radio--subscription .price.subscription-price"
    );
    if (priceEl && data.priceHTML) {
      priceEl.innerHTML = data.priceHTML;
    }

    const badgeEl = root.querySelector(
      ".wcsatt-options-prompt-radio--subscription .c-purchase-options__badge"
    );
    if (badgeEl) {
      if (data.discount > 0) {
        badgeEl.textContent = "-" + data.discount + "%";
        badgeEl.style.display = "";
      } else {
        badgeEl.style.display = "none";
      }
    }

    // Update the add-to-cart button price directly (only while a subscription
    // plan is the active choice — one-time keeps its own price).
    if (subInput && subInput.checked && data.priceText) {
      const btnPrice = root.querySelector(
        ".single_add_to_cart_button .c-cart-button__price"
      );
      if (btnPrice) btnPrice.textContent = data.priceText;
    }
  };

  // Delegate on the card so it keeps working if the plugin swaps the <select>.
  root.addEventListener("change", (e) => {
    const t = e.target;
    if (
      t &&
      t.classList &&
      t.classList.contains("wcsatt-options-product-dropdown")
    ) {
      sync();
    }
  });

  sync();
  window.setTimeout(sync, 200); // re-run after the plugin finishes hydrating
  window.setTimeout(sync, 600);
}

function initSubscriptionFrequencyButtons() {
  // "Dostawa co": with 2–4 plans show every plan as a button instead of a
  // dropdown (all options visible, one tap); with a single plan show plain
  // text under the box title instead of a one-item list. The plugin's
  // <select> stays the source of truth — a button sets its value and fires
  // `change`, so WCS ATT and initSubscriptionSchemePriceSync keep working.
  const root = document.querySelector(".c-product-card");
  if (!root) return;

  const MAX_BUTTONS = 4; // longer lists keep the dropdown

  // "Co 3 tygodnie za 48,45 zł (15% taniej)" -> "3 tygodnie"
  const planLabel = (text) =>
    text
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^co\s+/i, "")
      .replace(/\s+za\s+.*$/i, "");

  // Plan key "3_week" / "2_month" -> length in days, so buttons always read
  // shortest -> longest (the plugin lists the default plan first).
  const UNIT_DAYS = { day: 1, week: 7, month: 30, year: 365 };
  const planDays = (value) => {
    const m = /^(\d+)_(day|week|month|year)/.exec(value || "");
    return m ? parseInt(m[1], 10) * UNIT_DAYS[m[2]] : Number.MAX_SAFE_INTEGER;
  };

  const getSelect = () =>
    root.querySelector("select.wcsatt-options-product-dropdown");

  const render = () => {
    const select = getSelect();
    const subItem = root.querySelector(
      ".wcsatt-options-prompt-radio--subscription"
    );
    const wrapper = select && select.closest(".wcsatt-options-product-wrapper");
    if (!select || !subItem || !wrapper) return;

    const options = Array.from(select.options);
    const signature = options.map((o) => o.value).join("|");

    // Built already for these plans — only mirror the current selection.
    if (wrapper.dataset.labifyFrequency === signature) {
      wrapper.querySelectorAll(".c-purchase-frequency__option").forEach((b) => {
        const on = b.dataset.value === select.value;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      return;
    }

    wrapper.dataset.labifyFrequency = signature;
    wrapper.classList.remove("has-frequency-buttons", "is-single-plan");
    wrapper.querySelectorAll(".c-purchase-frequency").forEach((el) => el.remove());
    subItem
      .querySelectorAll(".c-purchase-options__frequency")
      .forEach((el) => el.remove());

    if (options.length === 1) {
      const label = subItem.querySelector(".c-purchase-options__label");
      if (label) {
        const note = document.createElement("p");
        note.className = "c-purchase-options__frequency";
        note.textContent = "dostawa co " + planLabel(options[0].textContent);
        label.insertAdjacentElement("afterend", note);
      }
      wrapper.classList.add("is-single-plan");
      return;
    }

    if (options.length > MAX_BUTTONS) return;

    const group = document.createElement("div");
    group.className = "c-purchase-frequency";
    group.setAttribute("role", "group");
    group.dataset.count = String(options.length);
    const legend = wrapper.querySelector(".wcsatt-options-product-dropdown-label");
    if (legend) {
      legend.id = legend.id || "c-purchase-frequency-label";
      group.setAttribute("aria-labelledby", legend.id);
    }

    const sorted = options
      .slice()
      .sort((a, b) => planDays(a.value) - planDays(b.value));

    sorted.forEach((o) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "c-purchase-frequency__option";
      button.dataset.value = o.value;
      button.textContent = planLabel(o.textContent);
      button.addEventListener("click", () => {
        const current = getSelect();
        if (current && current.value !== o.value) {
          current.value = o.value;
          current.dispatchEvent(new Event("change", { bubbles: true }));
        }
        render();
      });
      group.appendChild(button);
    });

    select.insertAdjacentElement("afterend", group);
    wrapper.classList.add("has-frequency-buttons");
    render(); // set the active button
  };

  // Plugin may change or re-render the <select> (e.g. variable products).
  root.addEventListener("change", (e) => {
    const t = e.target;
    if (t && t.classList && t.classList.contains("wcsatt-options-product-dropdown")) {
      render();
    }
  });

  render();
  window.setTimeout(render, 200); // after the plugin finishes hydrating
  window.setTimeout(render, 600);
  observeProductCard(root, render); // variable products re-render the <select>
}

function initSubscriptionPopover() {
  const popoverButton = document.querySelector(".subscription__howitworks");
  const popoverLayer = document.querySelector("#subscription__howitworks");
  const closeButton = document.querySelector(".subscription__howitworks__close");

  if (popoverButton && popoverLayer) {
    popoverButton.addEventListener("click", (event) => {
      event.preventDefault();
      popoverLayer.classList.add("active");
    });
  }

  if (closeButton && popoverLayer) {
    closeButton.addEventListener("click", (event) => {
      event.preventDefault();
      popoverLayer.classList.remove("active");
    });
  }

  if (popoverLayer) {
    popoverLayer.addEventListener("click", (event) => {
      if (!event.target.closest(".subscription__howitworks__layer__inner")) {
        popoverLayer.classList.remove("active");
      }
    });
  }
}

function initStickyAddToCartPrice() {
  const cartActions = document.querySelector(".cart__actions");
  const addToCartButton = document.querySelector(".single_add_to_cart_button");
  if (!cartActions || !addToCartButton) return;

  const originalParent = cartActions.parentElement;
  const placeholder = document.createElement("div"); // keeps layout height when docked
  placeholder.className = "c-cart-actions-placeholder";
  placeholder.setAttribute("aria-hidden", "true");

  const sentinel = document.createElement("div"); // observed to toggle sticky
  sentinel.className = "c-cart-actions-sentinel";
  sentinel.setAttribute("aria-hidden", "true");
  sentinel.style.height = "1px";
  sentinel.style.width = "1px";

  const stickyWrap = document.createElement("div");
  stickyWrap.className = "c-cart-actions-sticky";
  stickyWrap.setAttribute("aria-hidden", "true");
  const stickyInner = document.createElement("div");
  stickyInner.className = "c-cart-actions-sticky__inner";
  stickyWrap.appendChild(stickyInner);

  // Put sticky wrapper inside the same form to preserve submit behavior.
  const form = cartActions.closest("form.cart") || originalParent;
  if (form && form !== stickyWrap.parentElement) {
    form.appendChild(stickyWrap);
  }

  // Insert sentinel right before cartActions (original location marker).
  if (originalParent && !sentinel.parentElement) {
    originalParent.insertBefore(sentinel, cartActions);
  }

  const setPlaceholderHeight = () => {
    const h = cartActions.getBoundingClientRect().height;
    placeholder.style.height = h ? `${Math.ceil(h)}px` : "";
  };

  let isDocked = false;

  const dock = () => {
    if (isDocked) return;
    setPlaceholderHeight();
    originalParent.insertBefore(placeholder, cartActions);
    stickyInner.appendChild(cartActions);
    stickyWrap.classList.add("is-active");
    isDocked = true;
  };

  const undock = () => {
    if (!isDocked) return;
    if (placeholder.parentElement) {
      placeholder.parentElement.insertBefore(cartActions, placeholder);
      placeholder.remove();
    } else {
      originalParent.appendChild(cartActions);
    }
    stickyWrap.classList.remove("is-active");
    isDocked = false;
  };

  // Sticky should appear only after the original actions scrolled above viewport.
  const apply = () => {
    const rect = sentinel.getBoundingClientRect();
    if (rect.top < 0) dock();
    else undock();
  };

  window.addEventListener("scroll", apply, { passive: true });
  apply();

  window.addEventListener("resize", () => {
    if (isDocked) setPlaceholderHeight();
  });
}

function initAddToCartLabelWithPrice() {
  const defaultLabel = "Dodaj do koszyka";
  let isApplying = false;
  const getAddToCartButton = () =>
    document.querySelector(".c-product-card .single_add_to_cart_button") ||
    document.querySelector(".single_add_to_cart_button");
  // A template may set its own label (variable-subscription.php: "Dodaj subskrypcję do koszyka").
  const getBaseLabel = (button) =>
    (button && button.dataset.baseLabel) || defaultLabel;
  const escapeHtml = (s) =>
    String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const getCheckedPriceText = () => {
    const checked = document.querySelector(
      ".c-product-card input[name='subscribe-to-action-input']:checked"
    );
    if (!checked) return "";

    const ds = checked.dataset ? checked.dataset.priceText : "";
    if (ds) return ds.replace(/\s+/g, " ").trim();

    // Fallbacks when markup is re-rendered by the plugin.
    const li = checked.closest(".wcsatt-options-prompt-radio");
    const label = checked.closest("label") || (li ? li.querySelector("label") : null);
    const scope = label || li;
    const priceEl = scope ? scope.querySelector(".price, .woocommerce-Price-amount") : null;
    const txt = priceEl ? priceEl.textContent.trim() : "";
    return txt.replace(/\s+/g, " ").trim();
  };

  const getActivePriceText = () => {
    const activePriceEl = document.querySelector(
      ".c-product-card .wcsatt-options-prompt-radio.active .price"
    );
    const txt = activePriceEl ? activePriceEl.textContent.trim() : "";
    return txt.replace(/\s+/g, " ").trim();
  };

  const getFallbackWooPriceText = () => {
    // Fallback when WCS ATT radios are not present / not enhanced.
    // Prefer the promo price (<ins>) — on-sale one-time products render
    // <del> + <ins> above the button, and <del> comes first in the DOM.
    const wooPriceEl =
      document.querySelector(
        ".c-product-card .c-product-card__meta .price ins .woocommerce-Price-amount"
      ) ||
      document.querySelector(
        ".c-product-card .c-product-card__meta .price .woocommerce-Price-amount"
      );
    const txt = wooPriceEl ? wooPriceEl.textContent.trim() : "";
    return txt.replace(/\s+/g, " ").trim();
  };

  const apply = () => {
    if (isApplying) return;
    const addToCartButton = getAddToCartButton();
    if (!addToCartButton) return;

    const baseLabel = getBaseLabel(addToCartButton);
    const price =
      getCheckedPriceText() || getActivePriceText() || getFallbackWooPriceText();
    const flat = price ? `${baseLabel} ${price}` : baseLabel;
    const currentFlat =
      (addToCartButton.dataset.flatLabel || "").replace(/\s+/g, " ").trim();
    const currentAria = (addToCartButton.getAttribute("aria-label") || "")
      .replace(/\s+/g, " ")
      .trim();
    if (currentFlat === flat && currentAria === flat) return;

    isApplying = true;
    try {
      addToCartButton.innerHTML = price
        ? `<span class="c-cart-button__label">${escapeHtml(
            baseLabel
          )}</span><span class="c-cart-button__price">${escapeHtml(
            price
          )}</span>`
        : `<span class="c-cart-button__label">${escapeHtml(baseLabel)}</span>`;
      addToCartButton.setAttribute("aria-label", flat);
      addToCartButton.dataset.flatLabel = flat;
    } finally {
      isApplying = false;
    }
  };

  // Initial + on purchase option switch
  apply();

  // Some PDP blocks hydrate after initial load. Retry briefly.
  let retries = 0;
  const retry = () => {
    if (retries >= 10) return;
    retries += 1;
    apply();
    if (getCheckedPriceText() || getActivePriceText() || getFallbackWooPriceText()) return;
    window.setTimeout(retry, 100);
  };
  window.setTimeout(retry, 100);

  document.addEventListener("click", (e) => {
    if (e.target.closest(".c-product-card .wcsatt-options-prompt-radio label")) {
      window.requestAnimationFrame(apply);
    }
  });

  document.addEventListener("change", (e) => {
    if (e.target && e.target.matches(".c-product-card input[name='subscribe-to-action-input']")) {
      window.requestAnimationFrame(apply);
    }
  });

  // If plugin changes the button label (e.g. to "Subskrybuj"), force our label back.
  if (typeof MutationObserver !== "undefined") {
    const moBtn = new MutationObserver(() => {
      if (isApplying) return;
      apply();
    });
    const btn = getAddToCartButton();
    if (btn) {
      moBtn.observe(btn, { childList: true });
    }
  }

  // If price changes dynamically (variation / ajax), observe the card.
  const card = document.querySelector(".c-product-card");
  if (card && typeof MutationObserver !== "undefined") {
    const mo = new MutationObserver(() => {
      if (isApplying) return;
      apply();
    });
    mo.observe(card, { subtree: true, characterData: true, childList: true });
  }
}

(() => {
  const root = document.querySelector(".c-single-product");
  if (!root) return;

  toggleDescription(
    ".woocommerce-product-details__short-description__btn",
    ".woocommerce-product-details__short-description__desc"
  );
  initSubscriptionToggle();
  initDefaultSubscriptionSelected();
  initSubscriptionOptionsLayout();
  initSubscriptionPopover();
  initStickyAddToCartPrice();
  initAddToCartLabelWithPrice();
  initSubscriptionSchemePriceSync();
  initSubscriptionFrequencyButtons();
})();

